/**
 * Système de thèmes par filiale — CTO-FRONT-002.
 * Une classe .t-XXX appliquée sur <body> overrde les variables CSS du :root
 * (palette de 6 nuances de la couleur primaire + fond teinté).
 *
 * Convention : `filialeKey` du backend ↔ classe CSS du design system.
 */

export type ThemeClass =
  | 't-leadbeton'
  | 't-simgroup'
  | 't-royal'
  | 't-sinergie'
  | 't-davidco'
  | 't-textprint';

export const FILIALE_THEME: Record<string, ThemeClass> = {
  simgroup:       't-simgroup',
  leadbetonCI:    't-leadbeton',
  leadbetonBF:    't-leadbeton',
  royalLTCI:      't-royal',
  royalLTGuinee:  't-royal',
  sinergie:       't-sinergie',
  sigib:          't-davidco', // David & CO (anciennement SIGIB)
  davidco:        't-davidco',
  textprint:      't-textprint',
};

const ALL_THEME_CLASSES: ThemeClass[] = [
  't-leadbeton', 't-simgroup', 't-royal', 't-sinergie', 't-davidco', 't-textprint',
];

/**
 * Applique le thème correspondant à la filiale sur <body>.
 * Si la filiale n'a pas de mapping connu, applique le thème par défaut (Leadbeton).
 */
export const applyTheme = (filialeKey: string | null | undefined): ThemeClass => {
  const theme = (filialeKey && FILIALE_THEME[filialeKey]) || 't-leadbeton';
  const body  = document.body;
  ALL_THEME_CLASSES.forEach((c) => body.classList.remove(c));
  body.classList.add(theme);

  // Synchronise aussi <meta name="theme-color"> avec la couleur primaire
  // résolue depuis CSS vars (utile mobile PWA + browser chrome)
  const root = document.documentElement;
  const primary = getComputedStyle(root).getPropertyValue('--p').trim();
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta && primary) meta.setAttribute('content', primary);

  return theme;
};
